module.exports = __webpack_public_path__ + "img/avatar1.66caf070.png";